/* Materparade: sfondo che attraversa con gradualità i 40 colori delle Mater.
   Ogni elemento con [data-mp-cycle] riceve --cbg (colore) e --cfg (testo a contrasto), solo quando è visibile.
   Opzioni: data-mp-cycle="durata in secondi per colore" (default 2.4). Con "riduci movimento" resta fisso. */
(function () {
  'use strict';
  if (window.__mpCycle) return;
  window.__mpCycle = true;
  var PAL = ['#FFFFFF', '#F1E8D4', '#D5D3CE', '#8E8C87', '#46464B', '#1B1A19', '#F26B5B', '#C8312B', '#9E2A2B', '#6B1F2E', '#F4B795', '#E8892B', '#B85C38', '#8F3F22', '#F2D43D', '#F0B323', '#C9962E', '#B58E3C', '#B5CC8E', '#9CAF88', '#5FA14A', '#7A7A2E', '#1F7A5A', '#24432F', '#8EC5E8', '#7FD1C4', '#2CB1B5', '#1F5D6B', '#2155A6', '#1B2A4E', '#B9A6D8', '#7B4FA0', '#4B2A4F', '#E8C4C4', '#F4A6C0', '#C98B96', '#D1327A', '#DCC7A1', '#A57B54', '#5A3A29'];
  var RGB = PAL.map(function (h) { return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)]; });
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = [], raf = 0, last = 0;
  var LIGHT, DARK;

  function lum(c) {
    var f = c.map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
    return 0.2126 * f[0] + 0.7152 * f[1] + 0.0722 * f[2];
  }
  /* barra tortora quando l'intestazione non è trasparente sopra il video (e fuori dal menu a schermo intero) */
  function solid(el) {
    var h = el.closest('.mp-hdr');
    return !!h && !el.closest('.mp-menu') && (!h.classList.contains('mp-hdr--over') || h.classList.contains('is-scrolled'));
  }
  function paint(it) {
    var P = it.light ? (solid(it.el) ? DARK : LIGHT) : RGB, n = P.length, p = ((it.t % n) + n) % n, i = Math.floor(p), k = p - i;
    var a = P[i], b = P[(i + 1) % n];
    var c = [0, 1, 2].map(function (x) { return Math.round(a[x] + (b[x] - a[x]) * k); });
    var dark = lum(c) < 0.18; /* sotto questa luminosità il bianco contrasta meglio del nero (punto di parità ~0.18) */
    it.el.style.setProperty('--cbg', 'rgb(' + c.join(',') + ')');
    it.el.style.setProperty('--cfg', dark ? '#ffffff' : '#14091a');
    it.el.style.setProperty('--cfg-soft', dark ? 'rgba(255,255,255,0.9)' : 'rgba(20,9,26,0.88)');
    it.el.style.setProperty('--cline', dark ? 'rgba(255,255,255,0.28)' : 'rgba(20,9,26,0.28)');
  }
  function tick(now) {
    var dt = last ? Math.min(now - last, 80) : 16; last = now;
    var any = false;
    items.forEach(function (it) { if (it.on) { it.t += dt / 1000 / it.d; paint(it); any = true; } });
    raf = any ? requestAnimationFrame(tick) : 0;
    if (!any) last = 0;
  }
  function start() { if (!raf && !reduce) raf = requestAnimationFrame(tick); }
  function init() {
    LIGHT = RGB.filter(function (c) { return lum(c) > 0.16; });
    DARK = RGB.filter(function (c) { return lum(c) < 0.18; });
    [].forEach.call(document.querySelectorAll('[data-mp-cycle]'), function (el) {
      if (el._mpc) return;
      var light = el.hasAttribute('data-mp-cycle-light'); /* solo colori abbastanza chiari, per i testi su fondo scuro (logo) */
      var it = { el: el, light: light, t: Math.random() * 30, d: parseFloat(el.getAttribute('data-mp-cycle')) || 2.4, on: false };
      if (reduce) it.t = light ? 0 : 34; /* logo e piè di pagina fissi */
      el._mpc = it; items.push(it); paint(it);
      if (reduce || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (e) { it.on = e[0].isIntersecting; if (it.on) start(); }).observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
